import React from "react";

export default function Preloader({ load }) {
  return (
    <div className={`preloader ${load ? "" : "hidden"}`} aria-hidden={!load}>
      <div className="preloader__name">
        <span>Oguzhan&nbsp;Ozcelik</span>
      </div>
      <div className="preloader__bar"><i /></div>
    </div>
  );
}
